module.exports = __webpack_public_path__ + "static/media/doordash_logo.2cd0c7db.jpg";